import { gql } from "lib/apolloClient";

export const getOrganizationGradesQuery = gql`
  query getOrganizationGrades($id: ID!, $filters: GradeFilterInput) {
    node(id: $id, type: ORGANIZATION) {
      ... on Organization {
        id
        grades(filters: $filters) {
          id
          name
          globalGrade {
            id
            uid
            name
          }
        }
      }
    }
  }
`;

export const getOrganizationSubjectsQuery = gql`
  query getOrganizationSubjects($id: ID!, $filters: SubjectFilterInput) {
    node(id: $id, type: ORGANIZATION) {
      ... on Organization {
        id
        subjects(filters: $filters) {
          id
          name
        }
      }
    }
  }
`;
